/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIScrollingColumn from 'UIComponents/layout/UIScrollingColumn';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import UITabs from 'UIComponents/nav/UITabs';
import UITab from 'UIComponents/nav/UITab';
import GenericErrorBoundary from 'AdsUI/components/GenericErrorBoundary';
import ErrorPanelBody from 'AdsUI/components/ErrorPanelBody';
import makeLoadable from 'AdsUI/lib/makeLoadable';
import useRefreshStatuses, { MAX_CONCURRENT_REFRESH } from 'AdsUI/lib/useRefreshTrackingStatuses';
import { resetTrackingStatus } from 'AdsUI/actions/CampaignListActions';
import { OLAF } from 'HubStyleTokens/colors';
const TrackingErrorModalLoader = makeLoadable(() => import('AdsUI/components/tracking-error-modal/TrackingErrorModal'));
const TabsWrapper = styled.div.withConfig({
  displayName: "BaseTrackingErrorModal__TabsWrapper",
  componentId: "sc-1a0vr4h-0"
})(["position:sticky;top:0;left:0;background-color:", ";z-index:1;"], OLAF);

const BaseTrackingErrorModal = ({
  loading = false,
  onClose,
  groupedStatuses = {},
  name,
  dispatch: reduxDispatch
}) => {
  const [refreshState, concurrentRefreshes, refreshEntities, markSucceeded, markFailed] = useRefreshStatuses();
  const [needsRefresh, setNeedsRefresh] = useState(false);
  const [dismissedTkts, setDismissedTkts] = useState([]);
  const updateDismissedTkts = useCallback(tkts => {
    setDismissedTkts([...dismissedTkts, ...(tkts || [])]);
    setNeedsRefresh(true);
  }, [dismissedTkts]);
  const handleRefresh = useCallback(entities => {
    setNeedsRefresh(true);
    refreshEntities(entities);
  }, [refreshEntities, setNeedsRefresh]);
  const handleClose = useCallback(() => {
    if (needsRefresh) {
      reduxDispatch(resetTrackingStatus());
    }

    onClose();
  }, [needsRefresh, onClose, reduxDispatch]);
  return /*#__PURE__*/_jsxs(UIModalPanel, {
    width: 1000,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: handleClose
      }), /*#__PURE__*/_jsx(H2, {
        children: name ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "trackingStatusModal.titleWithName",
          options: {
            name
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "trackingStatusModal.title"
        })
      })]
    }), /*#__PURE__*/_jsx(GenericErrorBoundary, {
      fallback: /*#__PURE__*/_jsx(ErrorPanelBody, {}),
      children: /*#__PURE__*/_jsx(UIPanelBody, {
        children: /*#__PURE__*/_jsx(UIScrollingColumn, {
          maxHeight: "100%",
          children: /*#__PURE__*/_jsx(UIPanelSection, {
            children: /*#__PURE__*/_jsxs(UITabs, {
              defaultSelected: "active",
              Wrapper: TabsWrapper,
              children: [/*#__PURE__*/_jsx(UITab, {
                tabId: "active",
                title: I18n.text('trackingStatusModal.activeTab'),
                children: loading || !groupedStatuses ? /*#__PURE__*/_jsx(UILoadingSpinner, {
                  layout: "centered"
                }) : /*#__PURE__*/_jsx(TrackingErrorModalLoader, {
                  onClose: handleClose,
                  onRefreshTracking: handleRefresh,
                  onRefreshSuccess: markSucceeded,
                  onRefreshFailed: markFailed,
                  reachedMaxConcurrentRefresh: concurrentRefreshes >= MAX_CONCURRENT_REFRESH,
                  refreshStatuses: refreshState,
                  groupedStatuses: groupedStatuses,
                  isDismissedTab: false,
                  dismissedTkts: dismissedTkts,
                  updateDismissedTkts: updateDismissedTkts
                })
              }), /*#__PURE__*/_jsx(UITab, {
                tabId: "dismissed",
                title: I18n.text('trackingStatusModal.dismissedTab'),
                children: loading || !groupedStatuses ? /*#__PURE__*/_jsx(UILoadingSpinner, {
                  layout: "centered"
                }) : /*#__PURE__*/_jsx(TrackingErrorModalLoader, {
                  onClose: handleClose,
                  onRefreshTracking: handleRefresh,
                  onRefreshSuccess: markSucceeded,
                  onRefreshFailed: markFailed,
                  reachedMaxConcurrentRefresh: concurrentRefreshes >= MAX_CONCURRENT_REFRESH,
                  refreshStatuses: refreshState,
                  groupedStatuses: groupedStatuses,
                  isDismissedTab: true,
                  dismissedTkts: dismissedTkts
                })
              })]
            })
          })
        })
      })
    })]
  });
};

BaseTrackingErrorModal.propTypes = {
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  groupedStatuses: PropTypes.object,
  name: PropTypes.string
};
export default connect()(BaseTrackingErrorModal);